import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getListOperador } from "../api/api-operador";
import Select from "react-select";

export default function ModalFormSim({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const [listOperador, setListOperador] = useState([]);
    const [operadorSelected, setOperadorSelected] = useState(null);

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            console.log('formData');
            console.log(formData);
            const list = await getListOperador({ habilitado: 1 }, true, t);
            setListOperador(list);
            if (formData.idOperador !== null) {
                const operador = list.find(e => e.value === formData.idOperador);
                // console.log('operador');
                // console.log(operador);
                setOperadorSelected(operador);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const charLimits = {
        codigo: 64,
        linea: 128,
        iccid: 128,
        nota: 128,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            let message = "";
            if (String(formData.linea).trim().length === 0) {
                message = message + t("alert_must_enter_line") + '\n';
            }
            if (String(formData.iccid).trim().length === 0) {
                message = message + "ICCID" + '\n';
            }
            if (operadorSelected === null) {
                message = message + t("alert_must_select_carrier") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            onConfirm(formData, operadorSelected);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            codigo: "",
            linea: "",
            iccid: "",
            nota: "",
        });
        setOperadorSelected(null);
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>

                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("code")}</label>
                            <input
                                name="codigo"
                                value={formData.codigo}
                                onChange={handleInputChange}
                                placeholder={t("enter_code")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("linea")}<span className="text-red-500">*</span></label>
                            <input
                                name="linea"
                                value={formData.linea}
                                onChange={handleInputChange}
                                placeholder={t("enter_linea")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.linea.length}/{charLimits.linea}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">ICCID<span className="text-red-500">*</span></label>
                            <input
                                name="iccid"
                                value={formData.iccid}
                                onChange={handleInputChange}
                                placeholder={"iccid"}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.iccid.length}/{charLimits.iccid}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("carrier_provider")}<span className="text-red-500">*</span></label>
                            <Select
                                options={listOperador}
                                isSearchable={true}
                                isClearable={true}
                                value={operadorSelected}
                                onChange={(event) => setOperadorSelected(event)}
                                placeholder={t("label_select_carrier")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("note")}</label>
                            <input
                                name="nota"
                                value={formData.nota}
                                onChange={handleInputChange}
                                placeholder={t("enter_note")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nota.length}/{charLimits.nota}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
